import { api } from "@lumberset/api-client";
import { MyTickets, requestReportProblem } from "@lumberset/support-ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";
import { ticketsQuery } from "../../../lib/queries";

export const Route = createFileRoute("/_app/support/")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(ticketsQuery),
  component: SupportScreen,
});

function SupportScreen() {
  const navigate = useNavigate();
  return (
    <>
      <Crumbs trail={[{ label: "Support" }]} />
      <MyTickets
        client={api}
        onOpen={(id) => navigate({ to: "/support/$id", params: { id } })}
        onReport={requestReportProblem}
      />
    </>
  );
}
